import "../stylesheets/tailwind.css";

/**
 * Parallax block
 */
const parallaxElement = document.querySelectorAll(".praxent_parallax");
if (parallaxElement.length > 0) {
  import("./parallax").then((module) => {
    parallaxElement.forEach((element) => {
      module.parallaxHandler(element);
    });
  });
}

/**
 * Animated grid block
 */
const animatedGridElement = document.querySelectorAll(".praxent_animated-grid");
if (animatedGridElement.length > 0) {
  import("./animated-grid").then((module) => {
    animatedGridElement.forEach((element) => {
      module.animatedGridHandler(element);
    });
  });
}

/**
 * Animated row block
 */
const animatedRowElement = document.querySelectorAll(".praxent_posts-row");
if (animatedRowElement.length > 0) {
  import("./posts-row").then((module) => {
    animatedRowElement.forEach((element) => {
      module.animatedRowHandler(element);
    });
  });
}

/**
 * Testimonials block
 */
const testimonialsBlock = document.querySelectorAll(
  ".praxent_testimonials .swiper",
);
if (testimonialsBlock.length > 0) {
  import("./testimonials-slider").then((module) => {
    testimonialsBlock.forEach((element) => {
      module.scrollTo(element);
      module.testimonialsSlider(element);
    });
  });
}

/**
 * Case studies block
 */
const caseStudiesBlock = document.querySelectorAll(
  ".praxent_case-studies .slider",
);
if (caseStudiesBlock.length > 0) {
  import("./case-studies-slider").then((module) => {
    caseStudiesBlock.forEach((element) => {
      module.caseStudiesSlider(element);
    });
  });
}

/**
 * Dual image block
 */
const dualImageBlock = document.querySelectorAll(".praxent_dual-image");
if (dualImageBlock.length > 0) {
  import("./dual-image").then((module) => {
    dualImageBlock.forEach((element) => {
      module.dualImage(element);
    });
  });
}

/**
 * Plusminus toggler
 */
const plusminus = document.querySelectorAll(".plusminus");
plusminus.forEach((elem) => {
  elem.addEventListener("click", (evt) => {
    evt.target.classList.toggle("active");
  });
});

/**
 * Accordion toggler
 */
const accordionBlocks = document.querySelectorAll(".praxent_accordion");
const faqsBlocks = document.querySelectorAll(".praxent_faqs");
const methodologyBlock = document.querySelectorAll(".methodology_accordion");
if (accordionBlocks.length > 0) {
  import("./accordions").then((module) => {
    accordionBlocks.forEach((element) => {
      module.accordionHandler(element);
    });
  });
}
if (faqsBlocks.length > 0) {
  import("./accordions").then((module) => {
    faqsBlocks.forEach((element) => {
      module.accordionHandler(element);
    });
  });
}
if (methodologyBlock.length > 0) {
  import("./methodology").then((module) => {
    methodologyBlock.forEach((element) => {
      module.methodologyAccordionHandler(element);
    });
  });
}

/**
 * Job openings filters
 */
const jobOpeningsBlocks = document.querySelectorAll(".praxent_job-openings");
if (jobOpeningsBlocks.length > 0) {
  import("./careers-greenhouse-filters").then((module) => {
    jobOpeningsBlocks.forEach((element) => {
      module.filtersHandler();
    });
  });
}

/**
 * Testimonials block
 */
const imageTextBlock = document.querySelectorAll(
  ".praxent_image-text .swiper",
);
if (imageTextBlock.length > 0) {
  import("./image-text-slider").then((module) => {
    imageTextBlock.forEach((element) => {
      module.imageTextSlider(element);
    });
  });
}

/**
 * Vertical Slider block
 */
const verticalSliderBlock = document.querySelectorAll(
  ".praxent_vertical-slider .swiper",
);
if (verticalSliderBlock.length > 0) {
  import("./vertical-slider").then((module) => {
    verticalSliderBlock.forEach((element) => {
      module.verticalSlider(element);
    });
  });
}

/**
 * Results filters
 */

const archiveBlock = document.querySelectorAll('.praxent_cando-archive');
if (archiveBlock.length > 0) {
  import("./results-filters").then((module) => {
    archiveBlock.forEach((element) => {
      module.handleFilters(element);
    });
  });
}

/**
 * Shrink buttons
 */

// const shrinkableButtons = document.querySelectorAll('.shrink-btn');
// if (shrinkableButtons.length > 0) {
//   import("./shrink-buttons").then((module) => {
//     shrinkableButtons.forEach((element) => {
//       module.handleButton(element);
//     });
//   });
// }

if (document.querySelector(".mobile-nav-trigger")) {
  var hamburger = document.querySelector(".mobile-nav-trigger");
  var mobileNavContainer = document.querySelector("div#mobile");
  var mobileNav = document.getElementById("mobile-menu-container");
  var closeMobileNavTrigger = document.querySelector("#mobile-close-container #close-button");
  var mobileSubMenuItems = document.querySelectorAll("#menu-mobile-menu .menu-item");
  var mobileSubMenuContainers = document.querySelectorAll("#menu-mobile-menu .has-mega-menu");

  document.querySelectorAll("#mobile .submenu-back a").forEach((elem) => {
    elem.innerHTML = '';
  })


  handleMobileMenu(hamburger, mobileNavContainer, mobileNav);

  if (closeMobileNavTrigger) {
    closeMobileNavTrigger.addEventListener("click", function () {
      closeMobileNav(hamburger, mobileNavContainer, mobileNav);
      document.body.style.overflow = 'auto';
    });
  }

  if (mobileSubMenuItems) {
    mobileSubMenuContainers.forEach(function (n, index) {

      var mobileSubMenuTrigger = n.querySelector("a");
      mobileSubMenuTrigger.addEventListener("click", function (o) {
        n.classList.add("mobile-submenu-open");
        n.querySelector(".sub-menu").classList.add("active");
        var activeSubMenu = document.querySelector(".sub-menu.active");

        if (activeSubMenu) {
          var submenuBack = document.querySelector(".mobile-submenu-open .sub-menu.active .submenu-back a");
          // submenuBack.innerHTML = '';
          submenuBack.addEventListener("click", function () {
            activeSubMenu.classList.remove("active");
            handleSubmenuBack();
          });


          var subMenuBackButtons = document.querySelectorAll('.submenu-back-button');
          subMenuBackButtons.forEach(function (button) {
            button.addEventListener('click', function () {
              activeSubMenu.classList.remove("active");
              handleSubmenuBack();
            });
          });
        }

        var parentMenu = document.getElementById("menu-mobile-menu");
        if (parentMenu) {
          parentMenu.classList.add("menu-hidden");
        }

        if (!n.querySelector(".sub-menu.active")) {
          o.preventDefault();
          n.innerHTML += "<div id='submenu-back'><button><img src='/wp-content/themes/praxent/webroot/img/caret-right-white.svg' /></button></div>";
        }

        var submenuItems = document.querySelectorAll("#menu-mobile-menu > .menu-item");
        submenuItems.forEach(function (p) {
          p.classList.add("hidden");
        });
      });
    });
  }
}

function handleMobileMenu(hamburger, mobileNavContainer, mobileNav) {
  var praxentLogo = document.querySelectorAll('#praxent-logo')[1];

  hamburger.addEventListener("click", function () {
    hamburger.classList.toggle("is-active");

    if (hamburger.classList.contains('is-active')) {
      praxentLogo.src = "/wp-content/themes/praxent//assets/images/logo.svg";
      document.body.style.overflow = 'hidden';
    } else {
      praxentLogo.src = "/wp-content/themes/praxent//assets/images/logo.svg";
      document.body.style.overflow = 'auto';
    }

    mobileNavContainer.classList.toggle("menu-open");
    mobileNav.classList.toggle("open");

    if (!mobileNav.classList.contains("open")) {
      closeMobileNav(hamburger, mobileNavContainer, mobileNav);
    }
  });
}

function handleSubmenuBack() {
  var parentMenu = document.getElementById("menu-mobile-menu");
  var hiddenSubmenuItems = document.querySelectorAll("#menu-mobile-menu .menu-item.hidden");

  parentMenu.classList.remove("menu-hidden");

  if (hiddenSubmenuItems) {
    hiddenSubmenuItems.forEach(function (i) {
      i.classList.remove("hidden");

      if (i.classList.contains("mobile-submenu-open")) {
        i.classList.remove("mobile-submenu-open");
      }
    });
  }
}

function closeMobileNav(hamburger, mobileNavContainer, mobileNav) {
  var parentMenu = document.getElementById("menu-mobile-menu");
  var subMenu = document.querySelector(".sub-menu.active");
  var hiddenSubmenuItems = document.querySelectorAll("#menu-mobile-menu .menu-item.hidden");

  hamburger.classList.remove("is-active");
  mobileNavContainer.classList.remove("menu-open");
  mobileNav.classList.remove("open");

  if (parentMenu.classList.contains("menu-hidden")) {
    parentMenu.classList.remove("menu-hidden");
  }

  if (hiddenSubmenuItems) {
    hiddenSubmenuItems.forEach(function (i) {
      i.classList.remove("hidden");

      if (i.classList.contains("mobile-submenu-open")) {
        i.classList.remove("mobile-submenu-open");
      }
    });
  }

  if (subMenu) {
    subMenu.classList.remove("active");
  }
}

var navMegaMenuAnchors = document.querySelectorAll("#desktop li.has-mega-menu > a, #desktop li.has-single-dropdown > a");
if (navMegaMenuAnchors) {
  navMegaMenuAnchors.forEach(function (e, index) {
    e.innerHTML +=
      "<svg aria-hidden='true' data-prefix='fas' data-icon='angle-right' class='mega-menu-caret caret-" +
      index.toString() +
      " svg-inline--fa fa-angle-right fa-w-8' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 512'><path fill='#fff' d='M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z'></path></svg>";
  });
}

const progressList = document.querySelector('#progressList');
if (progressList !== undefined) {
  import("./post-progress-bar").then((module) => {
    module.postProgressBar(progressList);
  });
}